export const ORDER_PRODUCT_TYPE_PRODUCT = "product";
export const ORDER_PRODUCT_TYPE_SET = "set";

export const ORDER_PRODUCT_COMPONENT_TYPES = {
  string: "string",
  text: "text",
  phone: "phone",
  email: "email",
  integer: "integer",
  datepicker: "datepicker",
  datetimepicker: "datetimepicker",
  rangedatetimepicker: "rangedatetimepicker",
  dropdown: "dropdown",
};
export const STATUS_NEW = 1;
export const STATUS_RECALL = 2;
export const STATUS_CALL_OUT = 3;
export const STATUS_APPROVED = 4;
export const STATUS_DECLINE = 5;
export const STATUS_TRASH = 6;
export const STATUS_PAYMENT_LINK = 8;
export const STATUS_DONE = 9;
export const STATUS_APPROVED_PARTIAL_PAYMENT_LINK = 12;
export const CUSTOM_SUBSTATUS = 203;
export const SUB_STATUS_REVISION = 207;
export const SUB_STATUS_ADDRESS_CORRECTION = 208;
export const SUB_STATUS_CONNECTION_INTERRUPT = 205;
export const CORRECTION_SUBSTATUS = 206;
export const DELAYED_DELIVERY_SUBSTATUS = 202;

export const ORDER_TYPE_CONSULTING = 16;
export const FINAL_STATUSES = [4, 8, 9, 5, 6, 7, 10, 11];
export const STORAGE_ORDER_SCRIPS = "order-scripts";
export const STORAGE_ORDER_FORM = "order-form";
export const IGNORE_RELOAD_ORDER = "ignore-reload-order";
export const OPEN_AT_ORDER = "open-at-order";
export const OPEN_AT_ORDER_LOCAL = "open-at-order-local";
export const MAIN_PRODUCT_KEY = "main-product-key";
export const ORDER_TYPE_NEW = 1;
export const ORDER_TYPE_CREATED = 2;
export const ORDER_TYPE_POST_SALE = 6;
export const ORDER_TYPE_INCOME = 8;
export const ORDER_TYPE_LAST_CHANCE = 19;
export const ORDER_TYPE_DELIVERY_LOGISTIC = 22;

export const CORRECTION_DISCOUNT = 406;
export const CORRECTION_PRICE = 407;
export const CORRECTION_COMBO = 408;
export const CORRECTION_BILL = 409;

export const FORM_REQUEST_TYPE_MANUAL = "manual";
export const FORM_REQUEST_TYPE_PANEL = "panel";

export const SPECIAL_PRODUCT_IDS = [48, 49, 50, 51, 52, 53, 92, 112, 164, 167, 168, 169, 170, 171, 172, 173]; // Rhino Gold Ring и товары Waist, Matcha
export const MIN_PRECENTS_DISCOUNT = 40;
export const MAX_RECALL_DATE = 3;
export const MAX_RECALL_DATE_FOR_DELAYED_DELIVERY = 7;
export const MAX_RECALL_DATE_FOR_POST_SALE = 21;
export const RECALL_OFFSET_FOR_LANGUAGE_BARRIER = 30;
export const RECALL_OFFSET_FOR_CONNECTION_INTERRUPT = 60;